<template>
    <div>
        <h3>Device Readings</h3>
        <canvas v-if="!refresh" ref="chart" style="height: 300px;" />

        <div class="row">
            <div class="col-6">
                <label for="start_date">Start Date:</label>
                <input
                    id="start_date"
                    v-model="startDate"
                    class="form-control"
                    type="date"
                />
            </div>
            <div class="col-6">
                <label for="end_date">End Date:</label>
                <input
                    id="end_date"
                    v-model="endDate"
                    class="form-control"
                    type="date"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Chartisan from '../../../libraries/chart/chartisan';
import ChartisanHooks from '../../../libraries/chart/chartisan-hooks';

export default {
  name: 'StatisticsChart',

  props: {
    device: {
      type: Object,
      required: true,
    },
    legend: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data: () => {
    const today = new Date();
    const startDate = new Date(new Date().setDate(today.getDate() - 90));

    const pad = function (n, width, z = '0') {
      n = `${n}`;
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    };

    return {
      chart: undefined,
      refresh: false,
      startDate: `${startDate.getFullYear()}-${pad(
        startDate.getMonth() + 1,
        2,
      )}-${pad(startDate.getDate(), 2)}`,
      endDate: `${today.getFullYear()}-${pad(
        today.getMonth() + 1,
        2,
      )}-${pad(today.getDate(), 2)}`,
    };
  },

  computed: {
    url() {
      return `/api/chart/reading_percentages?startDate=${this.startDate}&endDate=${this.endDate}&device=${this.device.hash}`;
    },
  },

  watch: {
    startDate() {
      this.updateGraph();
    },
    endDate() {
      this.updateGraph();
    },
  },

  mounted() {
    this.chart = new Chartisan({
      el: this.$refs.chart,
      url: this.url,
      hooks: new ChartisanHooks()
        .tooltip(true)
        .legend({
          display: this.legend,
          position: 'bottom',
        })
        .datasets([{ type: 'line' }]),
    });
  },

  methods: {
    updateGraph() {
      this.refresh = true;

      // This is a ugly hack to get it to refresh without an error
      this.$nextTick(() => {
        this.refresh = false;

        this.$nextTick(() => {
          this.chart = new Chartisan({
            el: this.$refs.chart,
            url: this.url,
            hooks: new ChartisanHooks()
              .tooltip(true)
              .legend({
                display: this.legend,
                position: 'bottom',
              })
              .datasets([{ type: 'line' }]),
          });
        });
      });
    },
  },
};
</script>
